<div class="edit-media">
  <div class="header">
    <div class="header-title">{{ 'dynamicContent.editAsset' | translate }}</div>
  </div>
  <div class="edit-title">
    <title-translate [asset]="data.asset" [languages]="data.availableLanguages" [packageLang]="data.packageLang" (changed)="titleUpdate()"
                     [selectedLanguages]="data.asset.translatedTitles" [showSave]="false"
                     [showInFrontCheckbox]="data?.type === 'video' || data?.asset?.mimeType?.includes?.('video')"></title-translate>
  </div>
  <div class="button-container">
    <button (click)="cancelChanges()"  class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
    <button (click)="onSave()" class="ibexfusion-raised-button" [disabled]="!titleUpdated" [class.mat-button-disabled]="!titleUpdated"
            mat-button>{{ 'general.save' | translate }}
    </button>
  </div>
</div>
